import { ClassNameProps, Item } from '../../../types/types';
import { featuresItems } from '../../../data/data';
import { useEffect, useState } from 'react';
const checkIsMobile = (): boolean => {
  return window.innerWidth <= 767.98;
};
const ListFeatures: React.FC<ClassNameProps> = ({ className }) => {
  const [isMobile, setIsMobile] = useState<boolean>(checkIsMobile());
  useEffect(() => {
    const handleResize = (): void => {
      setIsMobile(checkIsMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <>
      <ul className={className}>
        {featuresItems.map((item: Item) => (
          <li key={item.id} className={`${className}__item card`}>
            <div className={`${className}__inner`}>
              <h3 className={`${className}__title subtitle`}>{item.title}</h3>
              {item.list && item.list.length > 0 && (
                <div className={`${className}__box`}>
                  {item.list.map((textItem) => (
                    <p
                      key={textItem.id}
                      className={`${className}__text text-normal`}
                    >
                      {textItem.text}
                    </p>
                  ))}
                </div>
              )}
            </div>
            {!isMobile && item.img && (
              <img
                src={item.img}
                className={`${className}__img`}
                alt={item.title}
              />
            )}
            {!isMobile && item.svg && <>{item.svg}</>}
          </li>
        ))}
      </ul>
    </>
  );
};
export default ListFeatures;
